import script from "./BudgetsRecap.vue?vue&type=script&setup=true&lang=ts"
export * from "./BudgetsRecap.vue?vue&type=script&setup=true&lang=ts"

import "./BudgetsRecap.vue?vue&type=style&index=0&id=633d5ed9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-633d5ed9"]])

export default __exports__